<template>
  <div style="max-width: 1200px; margin: auto; padding: 1rem">
    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div class="header-title">Search Options</div>
          </template>
        </EsHeader>
      </div>
      <div class="tabs-container">
        <es-tabs :tabs="tabs" ref="tabs"></es-tabs>
      <router-view :loading="loading"/>
      </div>
    </div>
    <div>
      <div
        v-if="loading || searchResults.results"
        class="match-results--title is-flex"
        >
        <div
          class="is-flex has-text-weight-bold flex-align--center"
        >
          Search Results
          <span v-if="!loading">
            ({{ totalResults }})
          </span>
        </div>
        <button
          v-if="hasModule('LOCID:LOC:ADD')"
          @click="$router.push({ name: 'locationCreate' })"
          class="button is-primary margin-left--auto"
        >
          + Create a New Location
        </button>
      </div>
      <es-loader v-if="loading" style="margin: 6.5rem"/>
      <es-exception v-else-if="loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
      />
      <es-exception v-else-if="searchResults.totalResults === 0"
        exceptionMessage="No results found."
      />
      <template v-else-if="searchResults.results">
        <es-data-card :matchResults="searchResults"/>
        <legend-near-match :showDecisions="false"/>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import EsDataCard from '@/components/EsDataCard.vue';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import PermissionManager from '@/mixins/PermissionManager';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import LegendNearMatch from '@/components/LegendNearMatch.vue';
import EsTabs from '@/components/EsTabs.vue';

library.add(
  faExclamationTriangle,
  faTimes,
);

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'groupList' } },
      { text: 'Search Options', to: { } },
    ]);
  },
  components: {
    EsDataCard,
    EsException,
    EsHeader,
    EsLoader,
    LegendNearMatch,
    EsTabs,
  },
  data() {
    return {
      loading: false,
      loadingError: null,
      idType: null,
      id: null,
      searchSource: null,
      name: null,
      street1: null,
      street2: null,
      city: null,
      state: null,
      zip: null,
      searchResults: {},
      tabs: [
        {
          name: 'locationSearch',
          label: 'LOCATION SEARCH',
        },
        {
          name: 'idSearch',
          label: 'ID SEARCH',
        },
        {
          name: 'advancedSearch',
          label: 'ADVANCED SEARCH',
        },
      ],
    };
  },
  watch: {
    $route: 'checkQuery',
  },
  mounted() {
    this.checkQuery();
  },
  computed: {
    totalResults() {
      if (this.loading) {
        return '--';
      }
      return this.searchResults.totalResults;
    },
  },
  methods: {
    checkQuery() {
      const { query } = this.$route;
      if (query.searchSource) {
        if (query.searchSource === 'idSearch') {
          this.searchSource = query.searchSource;
          this.idType = query.idType;
          this.id = query.id;
        } else if (query.searchSource === 'advancedSearch' || query.searchSource === 'navbarSearch') {
          this.searchSource = query.searchSource;
          this.name = query.name;
          this.street1 = query.street1;
          this.street2 = query.street2;
          this.city = query.city;
          this.state = query.state;
          this.zip = query.zip;
        }
        this.executeSearch();
      } else {
        this.resetForm();
      }
    },
    async executeSearch() {
      this.toggleLoading();

      // Id Search
      if (this.searchSource === 'idSearch') {
        try {
          const res = await axios.post(`search/location?id=${this.id}&idType=${this.idType}`);
          this.searchResults = res.data;
        } catch (err) {
          this.loadingError = true;
        }
      } else if (this.searchSource === 'advancedSearch' || this.searchSource === 'navbarSearch') {
        try {
          const res = await axios.post('/search/location', ({
            name: this.name,
            street1: this.street1,
            street2: this.street2,
            city: this.city,
            stateCode: this.state,
            zip: this.zip,
          }));
          this.searchResults = res.data;
        } catch (err) {
          this.loadingError = true;
        }
      }
      this.toggleLoading();
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    resetForm() {
      this.loading = false;
      this.idType = null;
      this.id = null;
      this.searchSource = null;
      this.name = null;
      this.street1 = null;
      this.street2 = null;
      this.city = null;
      this.state = null;
      this.zip = null;
      this.searchResults = {};
    },
  },
};
</script>

<style lang="sass" scoped>
  .tabs-container
    padding: 0 1rem
  .reset
    width: 30px
  .match-results--title
    padding: 1rem 0
    margin-left: auto
    margin-right: auto
  .margin-left--auto
    margin-left: auto
  li
    border-left: 0 !important
</style>
